import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const Stream = () => {
  const [streams, setStreams] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add"); // "add" or "edit"
  const [currentItem, setCurrentItem] = useState({ id: 0, name: "" });

  useEffect(() => {
    fetchStreams();
  }, []);

  const fetchStreams = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/StreamMaster`);
      setStreams(response.data);
    } catch (error) {
      toast.error("Failed to fetch streams");
    }
  };

  const handleAdd = () => {
    setCurrentItem({ id: 0, name: "" });
    setModalMode("add");
    setShowModal(true);
  };

  const handleEdit = (item) => {
    setCurrentItem(item);
    setModalMode("edit");
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this item?")) {
      try {
        await axios.delete(`${baseUrl}/api/StreamMaster/${id}`);
        toast.success("Item deleted successfully");
        fetchStreams();
      } catch (error) {
        toast.error("Failed to delete item");
      }
    }
  };

  const handleSave = async () => {
    try {
      if (modalMode === "add") {
        await axios.post(`${baseUrl}/api/StreamMaster`, { ...currentItem, id: 0 });
        toast.success("Item added successfully");
      } else {
        await axios.put(`${baseUrl}/api/StreamMaster/${currentItem.id}`, currentItem);
        toast.success("Item updated successfully");
      }
      fetchStreams();
      setShowModal(false);
    } catch (error) {
      toast.error("Failed to save item");
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Stream</h2>
          <Button variant="primary" onClick={handleAdd}>Add New</Button>
        </div>

           <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
            <th>#</th>   
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {streams.map((item, index) => (
              <tr key={item.id}>
               <td>{index + 1}</td>        
                <td>{item.name}</td>
                <td>
                  <Button variant="warning" onClick={() => handleEdit(item)}>Edit</Button> &nbsp;
                  <Button variant="danger" onClick={() => handleDelete(item.id)}>Delete</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{modalMode === "add" ? "Add New" : "Edit"} Stream</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="formName">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter name"
                  value={currentItem.name}
                  onChange={(e) => setCurrentItem({ ...currentItem, name: e.target.value })}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>{modalMode === "add" ? "Add" : "Update"}</Button>
            <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>           
          </Modal.Footer>
        </Modal>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Stream;
